import React from "react"
// import PropTypes from "prop-types"
import logo from "../../../assets/brand/logo.svg"
// import androidIcon from "../../../assets/icons/android.svg"
// import appleIcon from "../../../assets/icons/apple.svg"
import style from "./Nav.module.css"
import Button from "../../../components/ui/button/Button"
// import { Link } from "gatsby"

const Nav = () => {
  return (
    <nav className={style.navbar}>
      <img className={style.logo} src={logo} alt="logo" />
      <div>
        <a
          href="https://fufilapp.netlify.app/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Button pressed={() => {}} label="GET STARTED" contained={true} />
        </a>
      </div>
      <div />
    </nav>
  )
}

Nav.propTypes = {}
Nav.defaultProps = {}

export default Nav
